
const first = val => Array.isArray(val) && val[0] || typeof val === 'string' && val || undefined

const params = () => new URL(window.location).searchParams

export const single = (key, params) => first(multiple(key, params))

export const multiple = (key, searchParams = params()) => {
	return [...searchParams.getAll(key), ...searchParams.getAll(`${key}[]`)]
}

export const removeQueryHash = url => {
	return url
		.replace(/\#.+$/, '')
		.replace(/\?.+$/, '')
}